import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DxRadioGroupModule } from 'devextreme-angular';
import { CtEvetHayirRadioService } from './ct-evet-hayir-radio.service';

@Component({
  selector: 'dk-ct-evet-hayir-radio',
  standalone: true,
  imports: [CommonModule, DxRadioGroupModule],
  templateUrl: './ct-evet-hayir-radio.component.html',
  styleUrls: ['./ct-evet-hayir-radio.component.scss'],
})
export class CtEvetHayirRadioComponent implements OnInit {
  @Output() valueChange = new EventEmitter<any>();
  @Input() selectedValue: string;
  @Input() label = '';
  public dataSource: any;

  constructor(private ctDabEvetHayirRadioService: CtEvetHayirRadioService) {}
  ngOnInit(): void {
    this.ctDabEvetHayirRadioService
      .ctDabEvetHayirDataStore()
      .subscribe((data) => {
        this.dataSource = data.items;
      });
  }
}
